export function keyFeaturesAnimate() {
	let $header = $(".header");
	let parent = $(".key-features ");
	let $stickyEl = parent.find(".wrap");
	let itemsList = parent.find(".key-features-list");
	let itemsLength = itemsList.find(".item, dt").length;

	$(window).on("load resize scroll", attachStickyElements);

	function attachStickyElements() {
		let windowWidth = this.innerWidth;

		let title = $stickyEl.find("h2,.h2, dt");
		let titleHeight = title.innerHeight();
		itemsList.css({"padding-top": titleHeight});

		if (windowWidth >= 1024 && itemsLength > 3) {
			let scrollTop = $(this).scrollTop();
			$stickyEl.each(function (i, item) {
				let $el = $(item);
				let $stickyHolder = $el.parents(".holder");

				let elHeight = $el.innerHeight();
				let holderHeight = $stickyHolder.innerHeight();
				let holderOffset = $stickyHolder.offset();
				let holderTop = holderOffset.top;
				let holderLeft = holderOffset.left;

				let headerHeight = $header.innerHeight();
				let offsetFromHeader = 30;
				let headerOffset = headerHeight + offsetFromHeader;

				let fixedStartPoint = holderTop - headerOffset;
				let fixedEndPoint = holderTop + holderHeight - elHeight - headerOffset;

				if (scrollTop >= fixedStartPoint && scrollTop < fixedEndPoint) {
					$el.removeClass("absolute").css({
						position: "fixed",
						top: headerOffset,
						left: holderLeft,
						bottom: "auto",
						marginTop: 0
					});
				} else if (scrollTop >= fixedEndPoint) {
					$el.css({
						position: "absolute",
						top: "auto",
						left: 0,
						bottom: 0
					});
				} else {
					$el.removeAttr("style");
				}
			});
		} else {
			$stickyEl.removeAttr("style");
		}
		if (windowWidth < 1024) {
			itemsList.removeAttr("style");
		}
	}
}


// WEBPACK FOOTER //
// ./assets/js/modules/keyFeaturesAnimate.js